import axios from 'axios';

export const accountsApi = axios.create({
  baseURL: 'https://iuniyvprs9.execute-api.sa-east-1.amazonaws.com/Prod',
  headers: {
    'Content-Type': 'application/json',
    'X-Esmt-Application': 'project-handler'
  },
});
